__webpack_require__.p = "/jungleredsalon/";